import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { V_URL } from '../../../../../BaseUrl';
import toast from 'react-hot-toast';
import axios from 'axios';
import Footer from '../../../Include/Footer';
import Header from '../../../Include/Header';
import Sidebar from '../../../Include/Sidebar';
import Loader from '../../../Include/Loader';
import { Pagination, Search } from '../../../Table';
import DropDown from '../../../../../Components/DropDown';
import moment from 'moment';
import { getPurReceive } from '../../../../../Store/prosafe/proTransaction/PurReceive/getPurReceive';
import { Check, Slash, X } from 'lucide-react';
import useModal from '../../../../../Components/CustomModal/useModal';
import AccRejModel from './components/AccRejModel';

const PurReceiveList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modal = useModal();
  const [disable, setDisable] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filter, setFilter] = useState({
    date: {
      start: null,
      end: null
    }
  });

  useEffect(() => {
    if (disable === true) {
      fetchData()
    }
  }, [disable]);

  const fetchData = () => {
    const bodyFormData = new URLSearchParams();
    bodyFormData.append("tag_number", 11);
    bodyFormData.append("search", search);
    bodyFormData.append("filter", JSON.stringify(filter));
    bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'))
    bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'))
    dispatch(getPurReceive({ formData: bodyFormData }))
    setDisable(false);
  };

  const entity = useSelector((state) => state?.getPurReceive?.user?.data) || [];

  const commentsData = useMemo(() => {
    let data = [...entity];
    if (search) {
      const keyword = search.toLowerCase();
      data = data.filter(
        (item) =>
          item.voucher_no?.toLowerCase().includes(keyword)
      );
    }
    setTimeout(() => setTotalItems(data.length), 0);
    return data.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [entity, search, currentPage, limit]);

  const handleRefresh = () => {
    setDisable(true);
    setSearch('');
    setFilter({
      date: {
        start: null,
        end: null
      }
    });
  };

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/prosafe/pro-delete-pu`;
        var bodyFormData = new URLSearchParams();
        bodyFormData.append("id", id);
        axios({
          method: "put",
          url: myurl,
          data: bodyFormData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }).then((response) => {
          if (response.data.success === true) {
            toast.success(response?.data?.message);
            setDisable(true);
          } else {
            toast.error(response?.data?.message);
          }
        }).catch((error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        });
      }
    });
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/main-store/user/dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">Purchase Receiving</li>
                </ul>
              </div>
            </div>
          </div>

          {disable === false ? (
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Purchase Receiving</h3>
                            <div className="doctor-search-blk">
                              <div className="top-nav-search table-search-blk">
                                <form>
                                  <Search
                                    onSearch={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                    }}
                                  />
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="btn">
                                    <img src="/assets/img/icons/search-normal.svg" alt="firm-searchBox" />
                                  </a>
                                </form>
                              </div>
                              <div className="add-group">
                                <Link to="/main-store/user/manage-purchase-receive" className="btn btn-primary add-pluss ms-2"
                                  data-toggle="tooltip" data-placement="top" title="Add">
                                  <img src="/assets/img/icons/plus.svg" alt="plus-icon" />
                                </Link>
                                <button type="button" onClick={handleRefresh} className="btn btn-primary doctor-refresh ms-2"
                                  data-toggle="tooltip" data-placement="top" title="Refresh">
                                  <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                          <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Receive Date</th>
                            <th>Receive No.</th>
                            <th>Project</th>
                            <th>Project No</th>
                            <th>Party</th>
                            <th>Received By</th>
                            <th>Payment Date</th>
                            <th>Item Count</th>
                            <th>Acc/Rej</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) =>
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>{moment(elem.receive_date).format('YYYY-MM-DD')}</td>
                              <td>{elem.voucher_no}</td>
                              <td>{`${elem.project_data?.name} ${elem.project_data?.project_no
                                  ? `(${elem.project_data?.project_no})`
                                  : ""
                                }` || "-"}</td>
                              {/* <td>{elem?.project_data?.project_no || '-'}</td> */}
                              <td>{elem?.manual_pro_no || "-"}</td>
                              <td>{elem?.party_data?.name || '-'}</td>
                              <td>{elem?.received_by?.name || '-'}</td>
                              <td>{elem.payment_date ? moment(elem.payment_date).format("YYYY-MM-DD") : "-"}</td>
                              <td>{elem.item_count || 0}</td>
                              <td>
                                <span className='table-acc-rej' data-toggle="tooltip" data-placement="top" title="Acc/Rej"
                                  onClick={() => {
                                    modal.show()
                                    setSelectedItem(elem?._id);
                                  }} style={{ cursor: "pointer" }}>
                                  <Check /><X />
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  <a href="#" className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button type="button" className="dropdown-item" onClick={() => navigate(`/main-store/user/view-purchase-receive`, { state: elem })}>
                                      <i className="fa-solid fa-eye m-r-5"></i> View
                                    </button>
                                    <button type="button" className="dropdown-item"
                                      onClick={() => navigate(`/main-store/user/manage-purchase-receive`, { state: elem })}>
                                      <i className="fa-solid fa-pen-to-square m-r-5"></i> Edit
                                    </button>
                                    <button type="button" className="dropdown-item"
                                      onClick={() => handleDelete(elem?._id, elem.voucher_no)}>
                                      <i className="fa fa-trash-alt m-r-5"></i> Delete
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                    <div className="row align-center mt-3 mb-2">
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                          aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                        <div className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate">
                          <Pagination
                            total={totalItems}
                            itemsPerPage={limit}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : <Loader />}
        </div>
        <Footer />
      </div>
      <AccRejModel
        modal={modal}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </div>
  )
}

export default PurReceiveList